import {useContext, useEffect, useState} from 'react'
import {Form, Modal, Row} from 'react-bootstrap'
import {getTagsFromEntityFull} from '../../../../services/documentos'
import {PartnerContext} from '../PartnerContexts'
import {ListGroupTags} from './ListGroup'

interface EntityTag {
  context: string
  field: string
  id: string
}

export const EntityTagsModal = () => {
  const {entityTagsModalOpen, closeEntityTagsModal} = useContext(PartnerContext)
  const [listTags, setListTags] = useState<EntityTag[]>([])
  // const {copy} = useClipboard()
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    fetchTags()
  }, [])

  const fetchTags = () => {
    getTagsFromEntityFull()
      .then((response) => {
        setListTags(response.data)
      })
      .catch((error) => console.log(error))
  }

  // Group tags by context
  const groupedTags =
    listTags?.reduce<Record<string, EntityTag[]>>((groups, tag) => {
      if (!groups[tag.context]) {
        groups[tag.context] = []
      }
      groups[tag.context].push(tag)
      return groups
    }, {}) ?? {}

  // Filter tags based on search term
  const filteredGroups = Object.entries(groupedTags).reduce<Record<string, EntityTag[]>>(
    (result, [context, tags]) => {
      const filteredTags = tags.filter(
        (tag) =>
          tag.context.toLowerCase().includes(searchTerm.toLowerCase()) ||
          tag.field.toLowerCase().includes(searchTerm.toLowerCase()) ||
          tag.id.toLowerCase().includes(searchTerm.toLowerCase())
      )
      if (filteredTags.length > 0) {
        result[context] = filteredTags
      }
      return result
    },
    {}
  )

  // transform these object to array
  const listTags2 = Object.entries(filteredGroups).map(([context, tags]) => ({
    label: context,
    fields: tags.map((tag) => ({
      label: tag.field,
      identifier: tag.id,
      tags: `{${tag.id}}`,
      type: tag.context,
    })),
  }))

  return (
    <Modal size='lg' show={entityTagsModalOpen} onHide={closeEntityTagsModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Etiquetas de ficha colaborador</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className='mb-3'>
            <ListGroupTags List={listTags2} />
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  )
}
